<app-risk-identification-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-risk-identification-filters>
<mat-card class="u-center-text" *ngIf="!daysDistributions?.length">
  <h4>{{'days-distributions.Nessuna distribuzione giornate trovata' | translate}}</h4>
  <button *ngIf="canAdd" mat-raised-button (click)="addDaysDistribution()">{{'shared.Aggiungi' | translate}}</button>
</mat-card>
<div class="table-container" [hidden]="!daysDistributions.length">
  <table mat-table matSort [dataSource]="daysDistributions">

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> {{'shared.Data' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        {{row.date | dateFormat}}
      </td>
    </ng-container>
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> {{'days-distributions.Persona' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        {{row.user?.name}} {{row.user?.lastname}}
      </td>
    </ng-container>
    <ng-container matColumnDef="days">
      <th mat-header-cell *matHeaderCellDef> {{'shared.Giornate' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        {{row.days}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button *ngIf="canAdd" mat-icon-button mat-raised-button color="accent"
          (click)="$event.stopPropagation();addDaysDistribution()">
          <mat-icon>playlist_add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
            <button mat-icon-button (click)="editDaysDistribution(row)">
              <mat-icon>create</mat-icon>
              {{'shared.Modifica' | translate}}
            </button>
          </mat-menu>
        </ng-container>
        <button *ngIf="canSelect" mat-raised-button color="primary"
          (click)="selectDaysDistribution(row)">{{'shared.Seleziona' | translate}}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSizeOptions[0]" [length]="total | async"
    showFirstLastButtons>
  </mat-paginator>
</div>
